import React, { useState } from 'react';
import { Input, Button, Table, Card, Space, message } from 'antd';
import { FaRegEye } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { AiOutlineDashboard } from 'react-icons/ai';
import { IoMdPricetags } from 'react-icons/io';
import '../CaseCategory/CaseCategory.css';
import AddNewCase from './AddNewCase';
import ViewCase from './ViewCase';
import DeleteCase from './DeleteCase';
import EditCase from './EditCase';

import { useCaseStudy } from '../../hooks/useCaseStudy';

const CaseStudy = () => {
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;

  const { useGetCaseStudies } = useCaseStudy();

  const { data: caseStudies = [], isLoading } = useGetCaseStudies();
  const activeCases = (caseStudies || []).filter(
    caseItem => !caseItem.is_archive
  );
  const sortedCases = [...activeCases].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  const handleSearch = e => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };

  // Prepare table data with filtering by searchText
  const filteredData = sortedCases
    .filter(item => item.title.toLowerCase().includes(searchText.toLowerCase()))
    .map((item, index) => ({
      key: item.id,
      sNo: index + 1,
      title: item.title,
      id: item.id,
    }));

  // Pagination slice
  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sNo',
      key: 'sNo',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <Space size="small">
          <Button icon={<IoMdPricetags />} type="primary">
            Attachments
          </Button>
          <ViewCase caseId={record.id} caseData={caseStudies} />
          <EditCase caseId={record.id} caseData={caseStudies} />
          <DeleteCase caseId={record.id} />
        </Space>
      ),
    },
  ];

  const paginationConfig = {
    current: currentPage,
    pageSize,
    total: filteredData.length,
    onChange: page => setCurrentPage(page),
    showSizeChanger: false,
  };

  return (
    <div className="mb-2 mt-2 p-4">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <h3>Case Study</h3>
          <h6 className="px-2 case-category">List</h6>
        </div>
        <div className="d-flex gap-2">
          <h6 className="d-flex align-items-center">
            <AiOutlineDashboard />
            Dashboard
          </h6>
          <h6 className="d-flex align-items-center">
            <MdKeyboardArrowRight />
            Case study
          </h6>
        </div>
      </div>

      <Card className="w-100 mt-2 p-1" title="Add" bordered={false}>
        <div className="container mt-4">
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex ms-auto gap-2">
              <Input.Search
                className="w-75"
                placeholder="Search by title"
                allowClear
                onChange={handleSearch}
                value={searchText}
              />
              <AddNewCase />
            </div>
          </div>

          <Table
            loading={isLoading}
            dataSource={paginatedData}
            columns={columns}
            pagination={paginationConfig}
            bordered
            size="middle"
            rowClassName="table-row"
          />
        </div>
      </Card>
    </div>
  );
};

export default CaseStudy;
